import moment from 'moment-timezone'

export const isTimestamp = (timestamp) => {
  const regex = /^\d{13}$/
  if (regex.test(timestamp)) {
    const date = new Date(Number(timestamp))
    return !isNaN(date.getTime())
  }
  return false
}

const has12HourFormat = (formatStr) => /h/.test(formatStr.replace(/HH/g, ''))

const parseDateInput = (date) => (isTimestamp(date) ? Number(date) : date)

const GMT_PREFIX = 'GMT '

const resolveFormatConfig = (format) => {
  if (format?.startsWith(GMT_PREFIX)) {
    const momentFormat = format.slice(GMT_PREFIX.length).replace(/\s*\[GMT[^\]]*\]\s*$/, '')
    return {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      format: `${momentFormat} [GMT]Z`
    }
  }
  return {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    format
  }
}

export const formatDateByLanguage = (date, language, format = 'YYYY/MM/DD HH:mm', arFormat = 'DD/MM/YYYY HH:mm') => {
  const parsedDate = parseDateInput(date)
  const { timeZone, format: resolvedFormat } = resolveFormatConfig(format)
  const { timeZone: arTimeZone, format: resolvedArFormat } = resolveFormatConfig(arFormat)
  const hasTimeFormat = /[hHms]/.test(resolvedArFormat)
  if (language === 'ar') {
    // 阿语特殊处理：12 小时制才追加上午/下午标记
    if (hasTimeFormat && has12HourFormat(resolvedArFormat)) {
      const hourIn24Format = parseInt(moment.tz(parsedDate, arTimeZone).format('H'), 10)
      const amPmMark = hourIn24Format < 12 ? 'ص' : 'م'
      return moment.tz(parsedDate, arTimeZone).format(`${resolvedArFormat}${amPmMark}`)
    }
    return moment.tz(parsedDate, arTimeZone).format(resolvedArFormat)
  } else {
    return moment.tz(parsedDate, timeZone).format(resolvedFormat)
  }
}

/**
 * 格式化时间
 * @param {*} date
 * @param {*} format
 * @returns
 */
export const formatDate = (date, format = 'YYYY/MM/DD HH:mm:ss') => {
  return moment(date).format(format)
}

/**
 * 将时间字符串转换为时间戳（零时区）
 * @param {*} dateStr
 * @returns
 */
export const convertToUTCMillis = (dateStr) => {
  const dateParts = dateStr.split(/[\s/:-]+/)
  // console.log('dateParts', dateParts)
  const date = new Date(
    Date.UTC(
      Number(dateParts[0]), // year
      Number(dateParts[1]) - 1, // month (0-indexed)
      Number(dateParts[2]), // day
      Number(dateParts[3]), // hour
      Number(dateParts[4]), // minute
      Number(dateParts[5]) // second
    )
  )
  return date.getTime()
}

/**
 * 获取设备时间搓, 进行大小判断
 * @param {*} date 需传入零时区时间格式字符串
 * @param {*} currentTime 当前时间戳
 * @returns
 */
export const compareWithCurrentUTC = (date, currentTime) => {
  if (!date) {
    return ''
  }
  const currentUTCTimestamp = currentTime || new Date().getTime()
  const inputUTCTimestamp = convertToUTCMillis(date)
  console.log('compareWithCurrentUTC', currentUTCTimestamp, inputUTCTimestamp)
  if (currentUTCTimestamp > inputUTCTimestamp) {
    return 'gt'
  } else if (currentUTCTimestamp === inputUTCTimestamp) {
    return 'et'
  } else {
    return 'lt'
  }
}
